import { TASK_STATUS } from 'modules/enumerations/enumerationIds';
import { formatDateForInput, getToday } from 'utilities/common';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

// Display names for every status a task can carry, including the retired Overdue status on older tasks
export const TASK_STATUS_TITLES = {
  [TASK_STATUS.ACTIVE]: 'Active',
  [TASK_STATUS.OPEN]: 'Open',
  [TASK_STATUS.WAITING_FOR_EE]: 'Waiting for EE',
  [TASK_STATUS.WAITING_FOR_VENDOR]: 'Waiting for Vendor',
  [TASK_STATUS.OVERDUE]: 'Overdue',
  [TASK_STATUS.COMPLETED]: 'Completed',
  [TASK_STATUS.CANCELED]: 'Canceled',
};

// The statuses a user can put an open task in from the task modal. The system only ever moves a task out of them
// to Completed or Canceled.
export const USER_TASK_STATUS_OPTIONS = [
  { id: TASK_STATUS.OPEN, title: TASK_STATUS_TITLES[TASK_STATUS.OPEN] },
  { id: TASK_STATUS.WAITING_FOR_EE, title: TASK_STATUS_TITLES[TASK_STATUS.WAITING_FOR_EE] },
  { id: TASK_STATUS.WAITING_FOR_VENDOR, title: TASK_STATUS_TITLES[TASK_STATUS.WAITING_FOR_VENDOR] },
];

// The task tables' Status filter. A fixed list rather than the TaskStatus enumeration so the Active default shows
// before the enumerations load; Active stands for every open task (see matchesStatusFilter)
export const TASK_STATUS_FILTER_OPTIONS = [
  { id: TASK_STATUS.ACTIVE, title: TASK_STATUS_TITLES[TASK_STATUS.ACTIVE] },
  ...USER_TASK_STATUS_OPTIONS,
  { id: TASK_STATUS.CANCELED, title: TASK_STATUS_TITLES[TASK_STATUS.CANCELED] },
  { id: TASK_STATUS.COMPLETED, title: TASK_STATUS_TITLES[TASK_STATUS.COMPLETED] },
];

export const getTaskStatusTitle = statusId =>
  TASK_STATUS_TITLES[Object.keys(TASK_STATUS_TITLES).find(id => isIdEqual(id, statusId))] || '';

export const isTaskClosed = task =>
  isIdEqual(task.taskStatusId, TASK_STATUS.COMPLETED) || isIdEqual(task.taskStatusId, TASK_STATUS.CANCELED);

// The Active filter lists every open task: Active, Open, Waiting for EE / Vendor and the retired Overdue. Any other
// status matches only itself.
export const matchesStatusFilter = (task, statusFilterId) =>
  isIdEqual(statusFilterId, TASK_STATUS.ACTIVE) ? !isTaskClosed(task) : isIdEqual(task.taskStatusId, statusFilterId);

// Overdue is worked out from the due date, not the status: an open task whose due date is before today
export const isTaskOverdue = task => !isTaskClosed(task) && !!task.dueDate && formatDateForInput(task.dueDate) < getToday();
